import { ProductOption } from 'types/product'
import { FilterOption } from '@helpers/filters/getFiltersOptionsState'

const sortOrderOptionsByPosition = (a: FilterOption, b: FilterOption): number =>
  b.position < a.position ? 1 : -1

const isDataAvailable = (
  productOptions: ProductOption[],
  filterOptions: FilterOption[]
) => {
  return productOptions?.length > 0 && filterOptions?.length > 0
}

function getFilterOptionsWithPreselectedOverrides(
  filterOptions: FilterOption[],
  productOptions: ProductOption[]
) {
  const preselectedFilterOptionsOverrides = productOptions
    .map(productOption => {
      const optionTypeOverrideValue =
        productOption.values.length === 1 ? productOption.values[0] : null

      if (optionTypeOverrideValue) {
        return {
          type: productOption.type,
          value: optionTypeOverrideValue,
          position: productOption.position
        }
      }

      return null
    })
    .filter(Boolean)

  return filterOptions
    .filter(
      filterOption =>
        !preselectedFilterOptionsOverrides.find(
          override => override.type === filterOption.type
        )
    )
    .concat(preselectedFilterOptionsOverrides)
}

export default function getSelectedFilterOptions(
  productOptions: ProductOption[],
  filterOptions: FilterOption[]
) {
  if (!isDataAvailable(productOptions, filterOptions)) {
    return []
  }

  const filterOptionsWithPreSelectedOverrides =
    getFilterOptionsWithPreselectedOverrides(filterOptions, productOptions)

  return filterOptionsWithPreSelectedOverrides
    .filter(filterOption => {
      return productOptions
        .find(option => option.type === filterOption.type)
        ?.values?.includes(filterOption.value)
    })
    .sort(sortOrderOptionsByPosition)
}
